import { QueryClient } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { chefKeys } from './query-keys'

const minute = 60 * 1000
const homeTabCache = { staleTime: minute, gcTime: minute }

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * minute,
      gcTime: 5 * minute,
      refetchOnWindowFocus: false,
      retry: (count, error) => !(isAxiosError(error) && [401, 403].includes(error.response?.status ?? 0)) && count < 2,
    },
    mutations: { retry: false },
  },
})

queryClient.setQueryDefaults(chefKeys.orders, homeTabCache)
queryClient.setQueryDefaults(chefKeys.shippingAll, homeTabCache)
